import { render, staticRenderFns } from "./OrderFormFits.vue?vue&type=template&id=52aa174f&scoped=true&"
import script from "./OrderFormFits.vue?vue&type=script&lang=js&"
export * from "./OrderFormFits.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormFits.vue?vue&type=style&index=0&id=52aa174f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa174f",
  null
  
)

export default component.exports